/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageFragment, PageFragment, FullPageFragment} from '@amblique/contentful/app/contentful/fragments/page';

/**
 * Get a single Page by ID (base - scalars only)
 */
export const getBasePageById = gql`
  ${BasePageFragment}

  query GetBasePageById($id: String!, $locale: String!, $preview: Boolean) {
    page(id: $id, locale: $locale, preview: $preview) {
      ...BasePageFragment
    }
  }
`;

/**
 * Get a single Page by ID (standard - 1 level deep)
 */
export const getPageById = gql`
  ${PageFragment}

  query GetPageById($id: String!, $locale: String!, $preview: Boolean) {
    page(id: $id, locale: $locale, preview: $preview) {
      ...PageFragment
    }
  }
`;

/**
 * Get a single Page by ID (full - 2 levels deep)
 */
export const getFullPageById = gql`
  ${FullPageFragment}

  query GetFullPageById($id: String!, $locale: String!, $preview: Boolean) {
    page(id: $id, locale: $locale, preview: $preview) {
      ...FullPageFragment
    }
  }
`;

/**
 * Get a single Page by slug (base - scalars only)
 */
export const getBasePageBySlug = gql`
  ${BasePageFragment}

  query GetBasePageBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    pageCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BasePageFragment
      }
    }
  }
`;

/**
 * Get a single Page by slug (standard - 1 level deep)
 */
export const getPageBySlug = gql`
  ${PageFragment}

  query GetPageBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    pageCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...PageFragment
      }
    }
  }
`;

/**
 * Get a single Page by slug (full - 2 levels deep)
 */
export const getFullPageBySlug = gql`
  ${FullPageFragment}

  query GetFullPageBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    pageCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...FullPageFragment
      }
    }
  }
`;

/**
 * Get all Page entries with pagination (base - scalars only)
 */
export const getBasePages = gql`
  ${BasePageFragment}

  query GetBasePages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageOrder]
    $where: PageFilter
    $preview: Boolean
  ) {
    pageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePageFragment
      }
    }
  }
`;

/**
 * Get all Page entries with pagination (standard - 1 level deep)
 */
export const getPages = gql`
  ${PageFragment}

  query GetPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageOrder]
    $where: PageFilter
    $preview: Boolean
  ) {
    pageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...PageFragment
      }
    }
  }
`;

/**
 * Get all Page entries with pagination (full - 2 levels deep)
 */
export const getFullPages = gql`
  ${FullPageFragment}

  query GetFullPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageOrder]
    $where: PageFilter
    $preview: Boolean
  ) {
    pageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullPageFragment
      }
    }
  }
`;
